export default __webpack_public_path__ + "static/media/ic_avax_24.75fe1256.svg";